import type { StorageAttachmentMeta } from "@/schema"

import { ApiContext, apiContextFetch } from "@/hooks/api/base"

export type StorageAttachmentRecordType = "Task" | "TaskTemplate" | "Project" | "ProjectTemplate" | "Meeting"

export interface CreateStorageAttachmentParams {
  recordType: StorageAttachmentRecordType
  recordId: string
  storageIntegrationId: string
  attachment: {
    external_id: string
    name: string
    mime_type?: string | null
    kind: "file" | "folder"
    web_url: string
    mode?: "reference" | "copy_per_instance"
  }
}

export function createStorageAttachment(context: ApiContext, params: CreateStorageAttachmentParams) {
  return apiContextFetch<{ storage_attachment: StorageAttachmentMeta }>(context, `storage_attachments`, {
    method: "POST",
    body: JSON.stringify({
      record_type: params.recordType,
      record_id: params.recordId,
      storage_integration_id: params.storageIntegrationId,
      storage_attachment: params.attachment,
    }),
  })
}

export function deleteStorageAttachment(context: ApiContext, id: string) {
  return apiContextFetch(context, `storage_attachments/${id}`, {
    method: "DELETE",
  })
}
